import React from "react";
import PropTypes from "prop-types";
import styles from "./SegmentedControl.module.css";

/**
 * Reusable segmented control for switching between options.
 * options: [{ value, label, icon? }]
 */
const SegmentedControl = ({
  options = [],
  value,
  onChange,
  ariaLabel = "Options",
}) => {
  return (
    <div className={styles.root} role="tablist" aria-label={ariaLabel}>
      {options.map((option) => {
        const isActive = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`${styles.segment} ${isActive ? styles.segmentActive : ""}`}
            onClick={() => onChange?.(option.value)}
          >
            {option.icon ? (
              <span className={styles.icon} aria-hidden="true">
                {option.icon}
              </span>
            ) : null}
            <span>{option.label}</span>
          </button>
        );
      })}
    </div>
  );
};

SegmentedControl.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
    })
  ),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  ariaLabel: PropTypes.string,
};

export default SegmentedControl;
